import { EBenefitTypes } from "../enums/benefits.enums";
import { Entitlement } from "../types/benefits.types";

type BenefitsState = {
  byType: Partial<Record<EBenefitTypes, Entitlement>>;
  status: "idle" | "loading" | "succeeded" | "failed";
  error?: string;
  loadedAt?: string;
  subscriptions?: any | null;
};

export const initialState: BenefitsState = {
  byType: {},
  status: "idle",
  error: undefined,
  loadedAt: undefined,
  subscriptions: undefined,
};
